import ReactDOM from 'react-dom/client';
import React from 'react';
import { ProductForm } from './product-form';
import { TenantContext } from '../../context/tenant-context';
import { v2Component } from '../../index';

export function initProductForm() {
  const elements = document.getElementsByName('product-form');
  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const setRootAttributes = (o: any) => {
        Object.keys(o).forEach((k) => {
          element.setAttribute(k, o[k]);
        });
      };
      const root = ReactDOM.createRoot(element);
      const bootstrap = (mutations: MutationRecord[]) => {
        if (
          mutations.length === 0 ||
          mutations.find((r) => r.attributeName === 'data-rental-price' || r.attributeName === 'data-rental-duration')
        ) {
          const { tenant, contextPath, ...props } = Object.assign({}, element.dataset) as any;
          root.render(
            v2Component(
              <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
                <ProductForm {...props} setRootAttributes={setRootAttributes} />
              </TenantContext.Provider>,
            ),
          );
        }
      };

      const observer = new MutationObserver(bootstrap);
      observer.observe(element, { attributes: true });
      bootstrap([]);
    }
  });
}
